import React from 'react';

import { LazyLoadImage, makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    '& img, & .errorPlaceholder': {
      width: ({ width }) => width,
      height: ({ height }) => height,
      maxWidth: ({ maxWidth }) => maxWidth,
      maxHeight: ({ maxHeight }) => maxHeight,
      aspectRatio: ({ aspectRatio }) => aspectRatio,
    },
  },
}));

export default function PreviewImage({
  src,
  width,
  height,
  maxWidth,
  maxHeight,
  aspectRatio,
}) {
  const classes = useStyles({
    width,
    height,
    maxWidth,
    maxHeight,
    aspectRatio,
  });

  return (
    <LazyLoadImage src={src} visibleByDefault={true} className={classes.root} />
  );
}
